// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as LoaderHTML$OrcaPaymentPage from "../Components/LoaderHTML.bs.js";

function getScriptSrc() {
  var clickToPayMastercardBaseUrl = isProductionEnv ? "https://src.mastercard.com" : "https://sandbox.src.mastercard.com";
  return clickToPayMastercardBaseUrl + "/srci/integration/2/lib.js";
}

var srcUiKitScriptSrc = "https://src.mastercard.com/srci/integration/components/src-ui-kit/src-ui-kit.esm.js";

var srcUiKitCssHref = "https://src.mastercard.com/srci/integration/components/src-ui-kit/src-ui-kit.css";

var recognitionTokenCookieName = "__mastercard_click_to_pay";

var orderIdRef = {
  contents: ""
};

var clickToPayWindowRef = {
  contents: null
};

function handleCloseClickToPayWindow() {
  var $$window = clickToPayWindowRef.contents;
  if (!($$window == null)) {
    $$window.close();
    clickToPayWindowRef.contents = null;
    return ;
  }
  
}

function handleOpenClickToPayWindow() {
  clickToPayWindowRef.contents = open("", "ClickToPayWindow", "width=480,height=600");
  LoaderHTML$OrcaPaymentPage.injectLoader(clickToPayWindowRef.contents);
}

function setLocalStorage(key, value) {
  window.localStorage.setItem(key, value);
}

function getLocalStorage(key) {
  return window.localStorage.getItem(key);
}

function deleteLocalStorage(key) {
  window.localStorage.removeItem(key);
}

function getIdentityType(identityType) {
  if (identityType === "EMAIL_ADDRESS") {
    return "EMAIL_ADDRESS";
  } else {
    return "MOBILE_PHONE_NUMBER";
  }
}

function clickToPayCardItemToObjMapper(json) {
  var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
  return {
          srcDigitalCardId: Utils$OrcaPaymentPage.getString(dict, "srcDigitalCardId", ""),
          panLastFour: Utils$OrcaPaymentPage.getString(dict, "panLastFour", ""),
          panExpirationMonth: Utils$OrcaPaymentPage.getString(dict, "panExpirationMonth", ""),
          panExpirationYear: Utils$OrcaPaymentPage.getString(dict, "panExpirationYear", ""),
          paymentCardDescriptor: Utils$OrcaPaymentPage.getString(dict, "paymentCardDescriptor", ""),
          digitalCardData: {
            descriptorName: Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(dict, "digitalCardData"), "descriptorName", "")
          },
          panBin: Utils$OrcaPaymentPage.getString(dict, "panBin", "")
        };
}

function clickToPayTokenItemToObjMapper(json) {
  var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
  return {
          dpaId: Utils$OrcaPaymentPage.getString(dict, "dpa_id", ""),
          dpaName: Utils$OrcaPaymentPage.getString(dict, "dpa_name", ""),
          locale: Utils$OrcaPaymentPage.getString(dict, "locale", ""),
          transactionAmount: Utils$OrcaPaymentPage.getFloat(dict, "transaction_amount", 0.0),
          transactionCurrencyCode: Utils$OrcaPaymentPage.getString(dict, "transaction_currency_code", ""),
          acquirerBIN: Utils$OrcaPaymentPage.getString(dict, "acquirer_bin", ""),
          acquirerMerchantId: Utils$OrcaPaymentPage.getString(dict, "acquirer_merchant_id", ""),
          merchantCategoryCode: Utils$OrcaPaymentPage.getString(dict, "merchant_category_code", ""),
          merchantCountryCode: Utils$OrcaPaymentPage.getString(dict, "merchant_country_code", ""),
          cardBrands: Utils$OrcaPaymentPage.getArray(dict, "card_brands").map(function (item) {
                return Core__Option.getOr(Core__JSON.Decode.string(item), "");
              }),
          email: Utils$OrcaPaymentPage.getString(dict, "email", ""),
          provider: Utils$OrcaPaymentPage.getString(dict, "provider", "mastercard")
        };
}

var mcCheckoutService = {
  contents: undefined
};

function initializeMastercardCheckout(clickToPayToken, logger) {
  var match = window.MastercardCheckoutServices;
  if (match !== undefined) {
    logger.setLogInfo(Core__Option.getOr(JSON.stringify({
                  message: "MastercardCheckoutServices constructor found",
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    mcCheckoutService.contents = Caml_option.some(new (window.MastercardCheckoutServices)());
    var recognitionToken = window.localStorage.getItem(recognitionTokenCookieName);
    logger.setLogInfo(Core__Option.getOr(JSON.stringify({
                  message: "Recognition token fetched",
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    var params_srcDpaId = clickToPayToken.dpaId;
    var params_dpaData = {
      dpaName: clickToPayToken.dpaName
    };
    var params_dpaTransactionOptions = {
      dpaLocale: clickToPayToken.locale,
      authenticationPreferences: {
        payloadRequested: "AUTHENTICATED"
      },
      paymentOptions: [{
          dpaDynamicDataTtlMinutes: 15,
          dynamicDataType: "CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM"
        }],
      transactionAmount: {
        transactionAmount: clickToPayToken.transactionAmount,
        transactionCurrencyCode: clickToPayToken.transactionCurrencyCode
      },
      acquirerBIN: clickToPayToken.acquirerBIN,
      acquirerMerchantId: clickToPayToken.acquirerMerchantId,
      merchantCategoryCode: clickToPayToken.merchantCategoryCode,
      merchantCountryCode: clickToPayToken.merchantCountryCode
    };
    var params_cardBrands = clickToPayToken.cardBrands;
    var params = {
      srcDpaId: params_srcDpaId,
      dpaData: params_dpaData,
      dpaTransactionOptions: params_dpaTransactionOptions,
      cardBrands: params_cardBrands,
      checkoutExperience: "WITHIN_CHECKOUT"
    };
    var params$1;
    if (recognitionToken == null) {
      params$1 = params;
    } else {
      var newrecord = Caml_obj.obj_dup(params);
      newrecord.recognitionToken = recognitionToken;
      params$1 = newrecord;
    }
    try {
      var service = mcCheckoutService.contents;
      if (service !== undefined) {
        logger.setLogInfo(Core__Option.getOr(JSON.stringify({
                      message: "Mastercard Checkout Service initialized",
                      scheme: "MASTERCARD"
                    }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
        return Core__Promise.$$catch(Caml_option.valFromOption(service).init(params$1).then(function (resp) {
                        logger.setLogInfo(Core__Option.getOr(JSON.stringify({
                                      message: "Mastercard Checkout initialized",
                                      scheme: "MASTERCARD"
                                    }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                        return Promise.resolve(resp);
                      }), (function (err) {
                      logger.setLogError(Core__Option.getOr(JSON.stringify({
                                    message: "Error initializing Mastercard Checkout - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                                    scheme: "MASTERCARD"
                                  }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                      return Promise.reject(err);
                    }));
      } else {
        logger.setLogError(Core__Option.getOr(JSON.stringify({
                      message: "Mastercard Checkout Service not initialized",
                      scheme: "MASTERCARD"
                    }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
        return Promise.reject(Caml_js_exceptions.internalToOCamlException("Mastercard Checkout Service not initialized"));
      }
    }
    catch (raw_error){
      var error = Caml_js_exceptions.internalToOCamlException(raw_error);
      logger.setLogError(Core__Option.getOr(JSON.stringify({
                    message: "Error initializing Mastercard Checkout - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(error)),
                    scheme: "MASTERCARD"
                  }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      return Promise.reject(error);
    }
  } else {
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "MastercardCheckoutServices is not available",
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return Promise.reject(Caml_js_exceptions.internalToOCamlException("MastercardCheckoutServices is not available"));
  }
}

async function getCards(logger) {
  try {
    var service = mcCheckoutService.contents;
    if (service !== undefined) {
      var cards = await Caml_option.valFromOption(service).getCards();
      logger.setLogInfo(Core__Option.getOr(JSON.stringify({
                    message: "Cards returned from API",
                    scheme: "MASTERCARD"
                  }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      return {
              TAG: "Ok",
              _0: cards
            };
    }
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Mastercard Checkout Service not initialized",
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Ok",
            _0: []
          };
  }
  catch (raw_error){
    var error = Caml_js_exceptions.internalToOCamlException(raw_error);
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Error getting cards - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(error)),
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Ok",
            _0: []
          };
  }
}

async function authenticate(payload, logger) {
  var authenticatePayload_windowRef = payload.windowRef;
  var authenticatePayload_accountReference = {
    consumerIdentity: {
      identityType: payload.consumerIdentity.identityType,
      identityValue: payload.consumerIdentity.identityValue
    }
  };
  var authenticatePayload = {
    windowRef: authenticatePayload_windowRef,
    requestRecognitionToken: true,
    accountReference: authenticatePayload_accountReference
  };
  try {
    var service = mcCheckoutService.contents;
    if (service !== undefined) {
      var authentication = await Caml_option.valFromOption(service).authenticate(authenticatePayload);
      var recognitionToken = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(authentication), "recognitionToken", "");
      if (recognitionToken !== "") {
        window.localStorage.setItem(recognitionTokenCookieName, recognitionToken);
      }
      return {
              TAG: "Ok",
              _0: authentication
            };
    }
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Mastercard Checkout Service not initialized",
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Error",
            _0: Caml_js_exceptions.internalToOCamlException("Mastercard Checkout Service not initialized")
          };
  }
  catch (raw_error){
    var error = Caml_js_exceptions.internalToOCamlException(raw_error);
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Error during authentication - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(error)),
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Error",
            _0: error
          };
  }
}

async function checkoutWithCard(windowRef, srcDigitalCardId, logger) {
  var checkoutPayload = {
    windowRef: windowRef,
    srcDigitalCardId: srcDigitalCardId,
    rememberMe: true
  };
  try {
    var service = mcCheckoutService.contents;
    if (service !== undefined) {
      var checkoutResp = await Caml_option.valFromOption(service).checkoutWithCard(checkoutPayload);
      return {
              TAG: "Ok",
              _0: checkoutResp
            };
    }
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Mastercard Checkout Service not initialized",
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Error",
            _0: Caml_js_exceptions.internalToOCamlException("Mastercard Checkout Service not initialized")
          };
  }
  catch (raw_error){
    var error = Caml_js_exceptions.internalToOCamlException(raw_error);
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Error during checkout with card - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(error)),
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Error",
            _0: error
          };
  }
}

async function encryptCardForClickToPay(cardNumber, expiryMonth, expiryYear, cvcNumber, logger) {
  var card = {
    primaryAccountNumber: cardNumber,
    panExpirationMonth: expiryMonth,
    panExpirationYear: expiryYear,
    cardSecurityCode: cvcNumber
  };
  try {
    var service = mcCheckoutService.contents;
    if (service !== undefined) {
      logger.setLogError(Core__Option.getOr(JSON.stringify({
                    message: "Encrypting card for Click to Pay",
                    scheme: "MASTERCARD"
                  }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      var encryptedCard = await Caml_option.valFromOption(service).encryptCard(card);
      return {
              TAG: "Ok",
              _0: encryptedCard
            };
    }
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Mastercard Checkout Service not initialized",
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Error",
            _0: Caml_js_exceptions.internalToOCamlException("Mastercard Checkout Service not initialized")
          };
  }
  catch (raw_error){
    var error = Caml_js_exceptions.internalToOCamlException(raw_error);
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Error encrypting card - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(error)),
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Error",
            _0: error
          };
  }
}

async function checkoutWithNewCard(payload, logger) {
  try {
    var service = mcCheckoutService.contents;
    if (service !== undefined) {
      var checkoutResp = await Caml_option.valFromOption(service).checkoutWithNewCard(payload);
      return {
              TAG: "Ok",
              _0: checkoutResp
            };
    }
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Mastercard Checkout Service not initialized",
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Error",
            _0: Caml_js_exceptions.internalToOCamlException("Mastercard Checkout Service not initialized")
          };
  }
  catch (raw_error){
    var error = Caml_js_exceptions.internalToOCamlException(raw_error);
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Error during checkout with new card - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(error)),
                  scheme: "MASTERCARD"
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return {
            TAG: "Error",
            _0: error
          };
  }
}

function loadClickToPayScripts(logger) {
  return new Promise((function (clickToPayScriptsPromiseResolve, param) {
                var scriptSelector = "script[src=\"" + srcUiKitScriptSrc + "\"]";
                var linkSelector = "link[href=\"" + srcUiKitCssHref + "\"]";
                var srcUiKitScriptPromise = new Promise((function (scriptPromiseResolve, param) {
                        var match = document.querySelector(scriptSelector);
                        if (!(match == null)) {
                          return scriptPromiseResolve();
                        }
                        var script = document.createElement("script");
                        script.type = "module";
                        script.src = srcUiKitScriptSrc;
                        script.onload = (function () {
                            logger.setLogInfo("ClickToPay UI Kit Script Loaded", "CLICK_TO_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
                            scriptPromiseResolve();
                          });
                        document.head.appendChild(script);
                      }));
                var srcUiKitCssPromise = new Promise((function (cssPromiseResolve, param) {
                        var match = document.querySelector(linkSelector);
                        if (!(match == null)) {
                          return cssPromiseResolve();
                        }
                        var link = document.createElement("link");
                        link.rel = "stylesheet";
                        link.href = srcUiKitCssHref;
                        link.onload = (function () {
                            logger.setLogInfo("ClickToPay UI Kit CSS Loaded", "CLICK_TO_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
                            cssPromiseResolve();
                          });
                        document.head.appendChild(link);
                      }));
                Core__Promise.$$catch(Promise.all([
                            srcUiKitScriptPromise,
                            srcUiKitCssPromise
                          ]).then(function (param) {
                          clickToPayScriptsPromiseResolve();
                          return Promise.resolve();
                        }), (function (param) {
                        logger.setLogError("ClickToPay UI Kit CSS Load Error", "CLICK_TO_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
                        return Promise.resolve();
                      }));
              }));
}

function loadMastercardScript(clickToPayToken, logger) {
  var scriptSrc = getScriptSrc();
  return new Promise((function (resolve, reject) {
                var scriptSelector = "script[src=\"" + scriptSrc + "\"]";
                var match = document.querySelector(scriptSelector);
                if (match == null) {
                  var script = document.createElement("script");
                  script.type = "text/javascript";
                  script.src = scriptSrc;
                  script.onload = (function () {
                      logger.setLogInfo("Script loaded, initializing Mastercard Checkout", "CLICK_TO_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
                      Core__Promise.$$catch(initializeMastercardCheckout(clickToPayToken, logger).then(function (resp) {
                                resolve(resp);
                                return Promise.resolve();
                              }), (function (err) {
                              reject(err);
                              return Promise.resolve();
                            }));
                    });
                  script.onerror = (function () {
                      logger.setLogError("Error loading Mastercard script", "CLICK_TO_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
                      var exn = Caml_js_exceptions.internalToOCamlException("Failed to load Mastercard script");
                      reject(exn);
                    });
                  document.head.appendChild(script);
                  return ;
                }
                logger.setLogInfo("Mastercard Script Already Exists", "CLICK_TO_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
                Core__Promise.$$catch(initializeMastercardCheckout(clickToPayToken, logger).then(function (resp) {
                          resolve(resp);
                          return Promise.resolve();
                        }), (function (err) {
                        reject(err);
                        return Promise.resolve();
                      }));
              }));
}

var make = React.memo(function (prim) {
      return React.createElement("src-mark", prim);
    });

var SrcMark = {
  make: make
};

var SrcLoader = {};

var SrcLearnMore = {};

function urlToParamUrlItemToObjMapper(url) {
  var params = url.replace("?", "").split("&");
  return params.filter(function (param) {
                return param !== "";
              }).map(function (param) {
              var paramValues = param.split("=");
              return {
                      key: Core__Option.getOr(paramValues[0], ""),
                      value: Core__Option.getOr(paramValues[1], "")
                    };
            });
}

async function signOut() {
  try {
    window.localStorage.removeItem(recognitionTokenCookieName);
    var service = mcCheckoutService.contents;
    if (service !== undefined) {
      var signOutResp = await Caml_option.valFromOption(service).signOut();
      return {
              TAG: "Ok",
              _0: signOutResp
            };
    }
    console.error("Mastercard Checkout Service not initialized");
    return {
            TAG: "Error",
            _0: Caml_js_exceptions.internalToOCamlException("Mastercard Checkout Service not initialized")
          };
  }
  catch (raw_error){
    var error = Caml_js_exceptions.internalToOCamlException(raw_error);
    console.error("Error during signOut:", error);
    return {
            TAG: "Error",
            _0: error
          };
  }
}

var make$1 = React.memo(function (prim) {
      return React.createElement("src-otp-input", prim);
    });

var SrcOtpInput = {
  make: make$1
};

function getStrFromActionCode(actionCode) {
  switch (actionCode) {
    case "SUCCESS" :
        return "SUCCESS";
    case "PENDING_CONSUMER_IDV" :
        return "PENDING_CONSUMER_IDV";
    case "FAILED" :
        return "FAILED";
    case "ERROR" :
        return "ERROR";
    case "ADD_CARD" :
        return "ADD_CARD";
    
  }
}

var defaultProfile = {
  maskedCards: []
};

function getCardsVisaUnified(getCardsConfig) {
  return window.VSDK.getCards(getCardsConfig);
}

function signOutVisaUnified() {
  return window.VSDK.unbindAppInstance();
}

function loadVisaScript(clickToPayToken, onLoadCallback, onErrorCallback) {
  var cardBrands = clickToPayToken.cardBrands.join(",");
  var scriptSrc = isProductionEnv ? "https://secure.checkout.visa.com/checkout-widget/resources/js/integration/v2/sdk.js?dpaId=" + clickToPayToken.dpaId + "&locale=" + clickToPayToken.locale + "&cardBrands=" + cardBrands + "&dpaClientId=" + clickToPayToken.dpaName : "https://sandbox.secure.checkout.visa.com/checkout-widget/resources/js/integration/v2/sdk.js?dpaId=" + clickToPayToken.dpaId + "&locale=" + clickToPayToken.locale + "&cardBrands=" + cardBrands + "&dpaClientId=" + clickToPayToken.dpaName;
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = scriptSrc;
  script.onload = onLoadCallback;
  script.onerror = onErrorCallback;
  document.body.appendChild(script);
}

function loadClickToPayUIScripts(logger, scriptLoadedCallback, scriptErrorCallback) {
  var scriptSelector = "script[src=\"" + srcUiKitScriptSrc + "\"]";
  var linkSelector = "link[href=\"" + srcUiKitCssHref + "\"]";
  var match = document.querySelector(scriptSelector);
  if (match == null) {
    var script = document.createElement("script");
    script.type = "module";
    script.src = srcUiKitScriptSrc;
    document.head.appendChild(script);
    script.onload = (function () {
        scriptLoadedCallback();
      });
    script.onerror = (function () {
        scriptErrorCallback();
      });
    logger.setLogInfo("ClickToPay UI Kit Script Loaded", "CLICK_TO_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
  }
  var match$1 = document.querySelector(linkSelector);
  if (!(match$1 == null)) {
    return ;
  }
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = srcUiKitCssHref;
  document.head.appendChild(link);
  logger.setLogInfo("ClickToPay UI Kit CSS Loaded", "CLICK_TO_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
}

function formatOrderId(orderId) {
  return Core__Option.getOr(orderId.replace("pay_", "").split("_secret_").at(0), "").slice(0, 40);
}

function getVisaInitConfig(token, clientSecret) {
  return {
          dpaTransactionOptions: {
            dpaLocale: token.locale,
            dpaBillingPreference: "NONE",
            paymentOptions: [{
                dpaDynamicDataTtlMinutes: 15,
                dynamicDataType: "CARD_APPLICATION_CRYPTOGRAM_LONG_FORM"
              }],
            transactionAmount: {
              transactionAmount: token.transactionAmount.toString(),
              transactionCurrencyCode: token.transactionCurrencyCode
            },
            payloadTypeIndicator: "FULL",
            merchantCountryCode: token.merchantCountryCode,
            consumerNationalIdentifierRequested: false,
            merchantCategoryCode: token.merchantCategoryCode,
            acquirerBIN: token.acquirerBIN,
            acquirerMerchantId: token.acquirerMerchantId,
            merchantOrderId: formatOrderId(Core__Option.getOr(clientSecret, ""))
          }
        };
}

async function checkoutVisaUnified(srcDigitalCardIdOpt, encryptedCardOpt, windowRef, newCardOpt, rememberMeOpt, clickToPayToken, orderId, consumer, request3DSAuthenticationOpt) {
  var srcDigitalCardId = srcDigitalCardIdOpt !== undefined ? srcDigitalCardIdOpt : "";
  var encryptedCard = encryptedCardOpt !== undefined ? encryptedCardOpt : "";
  var newCard = newCardOpt !== undefined ? newCardOpt : false;
  var rememberMe = rememberMeOpt !== undefined ? rememberMeOpt : false;
  var request3DSAuthentication = request3DSAuthenticationOpt !== undefined ? request3DSAuthenticationOpt : true;
  var baseDpaTransactionOptions_acquirerBIN = clickToPayToken.acquirerBIN;
  var baseDpaTransactionOptions_acquirerMerchantId = clickToPayToken.acquirerMerchantId;
  var baseDpaTransactionOptions_merchantName = clickToPayToken.dpaName;
  var baseDpaTransactionOptions_merchantOrderId = formatOrderId(orderId);
  var baseDpaTransactionOptions = {
    acquirerBIN: baseDpaTransactionOptions_acquirerBIN,
    acquirerMerchantId: baseDpaTransactionOptions_acquirerMerchantId,
    merchantName: baseDpaTransactionOptions_merchantName,
    merchantOrderId: baseDpaTransactionOptions_merchantOrderId
  };
  var dpaTransactionOptions;
  if (request3DSAuthentication) {
    var newrecord = Caml_obj.obj_dup(baseDpaTransactionOptions);
    newrecord.authenticationPreferences = {
      authenticationMethods: [{
          authenticationMethodType: "3DS",
          authenticationSubject: "CARDHOLDER",
          methodAttributes: {
            challengeIndicator: "01"
          }
        }],
      payloadRequested: "AUTHENTICATED"
    };
    dpaTransactionOptions = newrecord;
  } else {
    dpaTransactionOptions = baseDpaTransactionOptions;
  }
  var defaultConfig_payloadTypeIndicatorCheckout = "FULL";
  var defaultConfig_windowRef = Caml_option.some(windowRef);
  var defaultConfig = {
    payloadTypeIndicatorCheckout: defaultConfig_payloadTypeIndicatorCheckout,
    windowRef: defaultConfig_windowRef,
    dpaTransactionOptions: dpaTransactionOptions
  };
  var complianceSettings = {
    complianceResources: [
      {
        complianceType: "PRIVACY_POLICY",
        uri: "https://www.visa.com/en_us/checkout/legal/global-privacy-notice.html"
      },
      {
        complianceType: "REMEMBER_ME",
        uri: "https://www.visa.com/en_us/checkout/legal/global-privacy-notice/cookie-notice.html"
      },
      {
        complianceType: "TERMS_AND_CONDITIONS",
        uri: "https://www.visa.com/en_us/checkout/legal/terms-of-service.html"
      }
    ]
  };
  var checkoutConfig;
  if (newCard) {
    var clientCountry = Utils$OrcaPaymentPage.getClientCountry(Intl.DateTimeFormat().resolvedOptions().timeZone);
    var newrecord$1 = Caml_obj.obj_dup(defaultConfig);
    newrecord$1.complianceSettings = complianceSettings;
    newrecord$1.consumer = {
      consumerIdentity: {
        identityProvider: "SRC",
        identityType: "EMAIL_ADDRESS",
        identityValue: consumer.emailAddress
      },
      fullName: Core__Option.getOr(consumer.fullName, ""),
      emailAddress: consumer.emailAddress,
      mobileNumber: {
        phoneNumber: consumer.mobileNumber.phoneNumber,
        countryCode: consumer.mobileNumber.countryCode
      },
      countryCode: clientCountry.isoAlpha2,
      locale: Core__Option.getOr(clickToPayToken.locale.split("_").at(0), "")
    };
    newrecord$1.encryptedCard = encryptedCard;
    checkoutConfig = newrecord$1;
  } else if (rememberMe) {
    var newrecord$2 = Caml_obj.obj_dup(defaultConfig);
    newrecord$2.complianceSettings = complianceSettings;
    newrecord$2.srcDigitalCardId = srcDigitalCardId;
    checkoutConfig = newrecord$2;
  } else {
    var newrecord$3 = Caml_obj.obj_dup(defaultConfig);
    newrecord$3.srcDigitalCardId = srcDigitalCardId;
    checkoutConfig = newrecord$3;
  }
  return await window.VSDK.checkout(checkoutConfig);
}

function closeWindow(status, payload) {
  handleCloseClickToPayWindow();
  return {
          status: status,
          payload: payload
        };
}

function handleSuccessResponse(response) {
  var checkoutActionCode = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(response), "checkoutActionCode", "");
  switch (checkoutActionCode) {
    case "CANCEL" :
        return closeWindow("CANCEL", response);
    case "COMPLETE" :
        return closeWindow("COMPLETE", response);
    case "PAY_V3_CARD" :
        return closeWindow("PAY_V3_CARD", response);
    default:
      return closeWindow("ERROR", response);
  }
}

async function handleCheckoutWithCard(clickToPayProvider, srcDigitalCardId, logger, fullName, email, phoneNumber, countryCode, clickToPayToken, isClickToPayRememberMe, orderId, request3DSAuthenticationOpt) {
  var request3DSAuthentication = request3DSAuthenticationOpt !== undefined ? request3DSAuthenticationOpt : true;
  var $$window = clickToPayWindowRef.contents;
  if ($$window == null) {
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Click to Pay window reference is null",
                  scheme: clickToPayProvider
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return closeWindow("ERROR", null);
  }
  switch (clickToPayProvider) {
    case "VISA" :
        try {
          var consumer_fullName = fullName;
          var consumer_mobileNumber = {
            phoneNumber: phoneNumber,
            countryCode: countryCode
          };
          var consumer = {
            fullName: consumer_fullName,
            emailAddress: email,
            mobileNumber: consumer_mobileNumber
          };
          if (clickToPayToken === undefined) {
            return closeWindow("ERROR", null);
          }
          var checkoutResp = await checkoutVisaUnified(srcDigitalCardId, undefined, $$window, undefined, isClickToPayRememberMe, clickToPayToken, orderId, consumer, request3DSAuthentication);
          var actionCode = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(checkoutResp), "actionCode", "");
          if (actionCode === "SUCCESS") {
            logger.setLogInfo(Core__Option.getOr(JSON.stringify({
                          message: "Checkout successfull",
                          scheme: clickToPayProvider
                        }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
            return closeWindow("COMPLETE", checkoutResp);
          }
          logger.setLogError(Core__Option.getOr(JSON.stringify({
                        message: "Visa checkout failed with card, Action Code -> " + actionCode,
                        scheme: clickToPayProvider
                      }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
          return closeWindow("ERROR", null);
        }
        catch (raw_err){
          var err = Caml_js_exceptions.internalToOCamlException(raw_err);
          logger.setLogError(Core__Option.getOr(JSON.stringify({
                        message: "Visa checkout failed with card - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                        scheme: clickToPayProvider
                      }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
          return closeWindow("ERROR", null);
        }
    case "MASTERCARD" :
        var checkoutResp$1 = await checkoutWithCard($$window, srcDigitalCardId, logger);
        if (checkoutResp$1.TAG === "Ok") {
          return handleSuccessResponse(checkoutResp$1._0);
        } else {
          return closeWindow("ERROR", null);
        }
    case "NONE" :
        return closeWindow("ERROR", null);
    
  }
}

async function handleProceedToPay(srcDigitalCardIdOpt, encryptedCardOpt, isCheckoutWithNewCardOpt, isUnrecognizedUserOpt, emailOpt, phoneNumberOpt, countryCodeOpt, rememberMeOpt, logger, visaEncryptedCardOpt, clickToPayProvider, isClickToPayRememberMeOpt, clickToPayToken, orderIdOpt, fullNameOpt) {
  var srcDigitalCardId = srcDigitalCardIdOpt !== undefined ? srcDigitalCardIdOpt : "";
  var encryptedCard = encryptedCardOpt !== undefined ? encryptedCardOpt : null;
  var isCheckoutWithNewCard = isCheckoutWithNewCardOpt !== undefined ? isCheckoutWithNewCardOpt : false;
  var isUnrecognizedUser = isUnrecognizedUserOpt !== undefined ? isUnrecognizedUserOpt : false;
  var email = emailOpt !== undefined ? emailOpt : "";
  var phoneNumber = phoneNumberOpt !== undefined ? phoneNumberOpt : "";
  var countryCode = countryCodeOpt !== undefined ? countryCodeOpt : "";
  var rememberMe = rememberMeOpt !== undefined ? rememberMeOpt : false;
  var visaEncryptedCard = visaEncryptedCardOpt !== undefined ? visaEncryptedCardOpt : "";
  var isClickToPayRememberMe = isClickToPayRememberMeOpt !== undefined ? isClickToPayRememberMeOpt : false;
  var orderId = orderIdOpt !== undefined ? orderIdOpt : "";
  var fullName = fullNameOpt !== undefined ? fullNameOpt : "";
  var handleCheckoutWithNewCard = async function () {
    var $$window = clickToPayWindowRef.contents;
    if ($$window == null) {
      logger.setLogError(Core__Option.getOr(JSON.stringify({
                    message: "Click to Pay window reference is null",
                    scheme: clickToPayProvider
                  }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
      return closeWindow("ERROR", null);
    }
    switch (clickToPayProvider) {
      case "VISA" :
          var consumer_fullName = fullName;
          var consumer_mobileNumber = {
            phoneNumber: phoneNumber,
            countryCode: countryCode
          };
          var consumer = {
            fullName: consumer_fullName,
            emailAddress: email,
            mobileNumber: consumer_mobileNumber
          };
          try {
            if (clickToPayToken === undefined) {
              return closeWindow("ERROR", null);
            }
            var checkoutResp = await checkoutVisaUnified(undefined, visaEncryptedCard, $$window, true, undefined, clickToPayToken, orderId, consumer, undefined);
            var actionCode = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(checkoutResp), "actionCode", "");
            if (actionCode === "SUCCESS") {
              logger.setLogInfo(Core__Option.getOr(JSON.stringify({
                            message: "Checkout successfull",
                            scheme: clickToPayProvider
                          }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
              return closeWindow("COMPLETE", checkoutResp);
            }
            logger.setLogError(Core__Option.getOr(JSON.stringify({
                          message: "Visa checkout failed with new card, Action Code -> " + actionCode,
                          scheme: clickToPayProvider
                        }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
            return closeWindow("ERROR", null);
          }
          catch (raw_err){
            var err = Caml_js_exceptions.internalToOCamlException(raw_err);
            logger.setLogError(Core__Option.getOr(JSON.stringify({
                          message: "Visa checkout failed with new card - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                          scheme: clickToPayProvider
                        }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
            return closeWindow("ERROR", null);
          }
      case "MASTERCARD" :
          var cardBrand = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(encryptedCard), "cardBrand", "");
          var encryptedCard$1 = Utils$OrcaPaymentPage.getJsonFromDict(Utils$OrcaPaymentPage.getDictFromJson(encryptedCard), "encryptedCard", null);
          var consumer_mobileNumber$1 = {
            phoneNumber: phoneNumber,
            countryCode: countryCode
          };
          var consumer$1 = {
            emailAddress: email,
            mobileNumber: consumer_mobileNumber$1
          };
          var complianceSettings = {
            privacy: {
              acceptedVersion: "LATEST",
              latestVersion: "LATEST",
              latestVersionUri: "https://www.mastercard.com/global/click-to-pay/country-listing/privacy.html"
            },
            tnc: {
              acceptedVersion: "LATEST",
              latestVersion: "LATEST",
              latestVersionUri: "https://www.mastercard.com/global/click-to-pay/country-listing/terms.html"
            },
            cookie: {
              acceptedVersion: "LATEST",
              latestVersion: "LATEST",
              latestVersionUri: "https://www.mastercard.com/global/click-to-pay/en-us/privacy-notice.html"
            }
          };
          var payload = isUnrecognizedUser ? ({
                windowRef: $$window,
                cardBrand: cardBrand,
                encryptedCard: encryptedCard$1,
                rememberMe: rememberMe,
                consumer: consumer$1,
                complianceSettings: complianceSettings
              }) : ({
                windowRef: $$window,
                cardBrand: cardBrand,
                encryptedCard: encryptedCard$1,
                rememberMe: rememberMe,
                complianceSettings: complianceSettings
              });
          var checkoutResp$1 = await checkoutWithNewCard(payload, logger);
          if (checkoutResp$1.TAG === "Ok") {
            return handleSuccessResponse(checkoutResp$1._0);
          } else {
            return closeWindow("ERROR", null);
          }
      case "NONE" :
          return closeWindow("ERROR", null);
      
    }
  };
  try {
    if (Core__Option.isNone(Caml_option.nullable_to_opt(clickToPayWindowRef.contents))) {
      handleOpenClickToPayWindow();
    }
    if (isCheckoutWithNewCard) {
      return await handleCheckoutWithNewCard();
    } else {
      return await handleCheckoutWithCard(clickToPayProvider, srcDigitalCardId, logger, fullName, email, phoneNumber, countryCode, clickToPayToken, isClickToPayRememberMe, orderId, undefined);
    }
  }
  catch (raw_err){
    var err = Caml_js_exceptions.internalToOCamlException(raw_err);
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: "Error during checkout - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                  scheme: clickToPayProvider
                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
    return closeWindow("ERROR", null);
  }
}

var scriptId = "mastercard-external-script";

var manualCardId = "click_to_pay_manual_card";

var savedCardId = "click_to_pay_saved_card_";

var defaultCountry = {
  code: "",
  countryISO: ""
};

var defaultParamUrl = {
  key: "",
  value: ""
};

export {
  scriptId ,
  getScriptSrc ,
  srcUiKitScriptSrc ,
  srcUiKitCssHref ,
  recognitionTokenCookieName ,
  manualCardId ,
  savedCardId ,
  orderIdRef ,
  clickToPayWindowRef ,
  handleCloseClickToPayWindow ,
  handleOpenClickToPayWindow ,
  defaultCountry ,
  setLocalStorage ,
  getLocalStorage ,
  deleteLocalStorage ,
  getIdentityType ,
  clickToPayCardItemToObjMapper ,
  clickToPayTokenItemToObjMapper ,
  mcCheckoutService ,
  initializeMastercardCheckout ,
  getCards ,
  authenticate ,
  checkoutWithCard ,
  encryptCardForClickToPay ,
  checkoutWithNewCard ,
  loadClickToPayScripts ,
  loadMastercardScript ,
  SrcMark ,
  SrcLoader ,
  SrcLearnMore ,
  defaultParamUrl ,
  urlToParamUrlItemToObjMapper ,
  signOut ,
  SrcOtpInput ,
  getStrFromActionCode ,
  defaultProfile ,
  getCardsVisaUnified ,
  signOutVisaUnified ,
  loadVisaScript ,
  loadClickToPayUIScripts ,
  formatOrderId ,
  getVisaInitConfig ,
  checkoutVisaUnified ,
  closeWindow ,
  handleSuccessResponse ,
  handleCheckoutWithCard ,
  handleProceedToPay ,
}
/* make Not a pure module */
